export default __webpack_public_path__ + "static/media/0068.f494020d.png";